<template>
    <div class="content-page">
        <div class="tab-header">
            <el-button type="primary" size="medium" @click="toCreate">立即创建</el-button>
        </div>
        <div class="tab-content">
            <el-table :data="activeList" style="width: 100%" :max-height="550">
                <el-table-column align="center" prop="activityTitle" label="活动名称"></el-table-column>

                <el-table-column align="center" prop="startTime" label="活动时间">
                    <template slot-scope="scope">
                        {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="dayLimitTimesValue" label="基础抽奖次数"></el-table-column>

                <el-table-column align="center" prop="activityName" label="活动奖品">
                    <template slot-scope="scope">{{ getPrizeList(scope.row.lotteryPrizeJson) }}</template>
                </el-table-column>

                <el-table-column align="center" prop="timeStatus" label="活动状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.timeStatus == 1">未开始</span>
                        <span v-else-if="scope.row.timeStatus == 2">进行中</span>
                        <span v-else-if="scope.row.timeStatus == 3">已结束</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="totalJoinTimes" label="抽奖人次"></el-table-column>

                <el-table-column align="center" prop="totalWinningTimes" label="中奖人次"></el-table-column>

                <el-table-column align="center" prop="isEnable" label="是否启用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isEnable" active-color="#13ce66" inactive-color="#ff4949"
                            :active-value="1" :inactive-value="0" @change="startActive(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button type="warning" size="small"
                            @click="openDialog(scope.row.activityId)">中奖记录</el-button>
                        <!-- <el-button type="success" size="small" @click="startActive(scope.row.activityId)">启用</el-button> -->
                        <el-button type="primary" size="small"
                            @click="updateActive(scope.row.activityId)">编辑</el-button>
                        <el-popconfirm title="确定删除活动吗？" style="margin-left: 10px;" @confirm="delActive(scope.row)">
                            <el-button slot="reference" type="danger" size="small">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页器 -->
        <div class="pagination">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                layout="total, prev, pager, next, jumper" :total="pageTotal">
            </el-pagination>
        </div>

        <el-dialog title="中奖记录" :visible.sync="isShow" width="50%">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column align="center" prop="createTime" label="日期">
                </el-table-column>
                <el-table-column align="center" prop="phoneNum" label="手机号">
                </el-table-column>
                <el-table-column align="center" prop="prizeName" label="奖品">
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.prizeType == 3">
                            <el-button v-if="scope.row.isCash == 0" type="primary" size="small"
                                @click="checkPrize(scope.row)">核销</el-button>
                            <span v-else>已核销</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination @current-change="currentChange" :current-page.sync="cPage" :page-size="10"
                    layout="total, prev, pager, next, jumper" :total="cTotal">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》'
import { getLotteryList, deleteLottery, enableActivity, findLotteryRecordList, cashLotteryRecord } from "../api/index";

export default {
    components: {},
    props: [],
    data() {
        return {
            activeList: [],

            currentPage: 1,// 当前页码
            pageSize: 10,
            pageTotal: 0,

            isShow: false,
            tableData: [],

            cPage: 1,
            cTotal: 0,
        };
    },
    computed: {},
    watch: {},

    mounted() {
        this.getData();
    },

    methods: {
        // 获取列表数据
        async getData() {
            try {
                const tempData = {
                    pageNumber: this.currentPage,
                    pageSize: this.pageSize,
                    shopId: localStorage.shopId,
                };
                const res = await getLotteryList(tempData);
                this.activeList = res.data.list || [];
                this.pageTotal = res.data.totalCount || 0;

                this.activeList.forEach(item => {
                    item.lotteryPrizeJson = JSON.parse(item.lotteryPrizeJson);
                })

                console.log(this.activeList);
            } catch (error) {
                console.log(error);
            }
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },

        // 创建活动
        toCreate() {
            // let isFind = this.activeList.findIndex(item => item.timeStatus == 2);
            // if (isFind != -1) {
            //     this.$message.error("当前已存在活动，创建新的活动前请先结束或删除活动");
            // } else {
            //     this.$router.push("/luckyLottery/createAndEdit");
            // }

            this.$router.push("/luckyLottery/createAndEdit");
        },

        // 启用游戏
        async startActive(row) {
            try {
                const tempData = {
                    shopId: localStorage.shopId,
                    activityId: row.activityId,
                    isEnable: row.isEnable,
                }
                const res = await enableActivity(tempData);
                if (res.code == 1) {
                    this.$message.success("操作成功");
                } else {
                    this.$message.error("操作失败");
                }

                this.getData();
            } catch (error) {
                console.log(error);
            }
        },

        // 编辑活动
        updateActive(id) {
            this.$router.push(`/luckyLottery/createAndEdit?activityId=${id}`);
        },

        // 打开弹窗
        async openDialog(id) {
            this.isShow = true;
            this.currentId = id;
            await this.getRecord(id);
        },

        // 获取中奖记录
        async getRecord(id) {
            try {
                const tempData = {
                    pageNumber: this.cPage,
                    pageSize: 10,
                    activityId: id,
                    isWin: 1,
                }
                const res = await findLotteryRecordList(tempData);
                if (res.code == 1) {
                    this.cTotal = res.data.totalCount;
                    this.tableData = res.data.list || [];
                }
            } catch (error) {
                console.log(error);
            }
        },

        // 核销奖品
        async checkPrize(row) {
            try {
                const tempData = {
                    shopId: localStorage.shopId,
                    lotteryRecordId: row.lotteryRecordId,
                }
                const res = await cashLotteryRecord(tempData);
                if (res.code == 1) {
                    this.$message.success("成功核销");
                    this.getRecord(this.currentId);
                } else {
                    this.$message.error("核销失败，请重试");
                }
            } catch (error) {
                console.log(error);
            }
        },

        currentChange(val) {
            this.currentPage = val;
            this.getRecord(this.currentId);
        },


        // 删除活动
        async delActive(row) {
            if (row.timeStatus == 2) {
                this.$message.warning("删除失败，活动正在进行中");
                return;
            }

            try {
                const tempData = {
                    shopId: localStorage.shopId,
                    activityId: row.activityId,
                }
                const res = await deleteLottery(tempData);
                if (res.code == 1) {
                    this.$message.success("删除成功");
                    this.getData();
                } else {
                    this.$message.error("删除失败，请重试");
                }
            } catch (error) {
                console.log(error);
            }
        },

        // 设置活动奖品
        getPrizeList(data) {
            let arr = [];
            data.forEach(item => {
                arr.push(item.prizeName);
            })

            return arr.toString();
        }
    },
};
</script>

<style lang="less" scoped>
.pagination {
    display: flex;
    justify-content: center;
    width: 100%;

    background-color: #fff;

    margin-top: 10px;
}

.el-pagination::v-deep {
    padding: 5px 0;
}
</style>